.preview-option-button {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border-radius: 4px;
    background-color: transparent;
    border: none;
    cursor: pointer;
}

.preview-option-button:hover,
.preview-option-button:focus-visible {
    background-color: var(--list-hovered);
}
